module.exports = __webpack_public_path__ + "img/9788992711593.a75ab7c6.jpg";